import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import PageHeader from "@/components/PageHeader";
import { Stagger, staggerItem } from "@/components/Reveal";
import CTASection from "@/components/CTASection";
import { useSeo } from "@/lib/seo";
import { useBrand } from "@/context/SiteContext";
import { PRODUCTS } from "@/data/content";

export default function Products() {
  const brand = useBrand();
  useSeo({ title: "Products | Solar Inverters, Batteries, UPS, ESS & EV Charging", description: `Explore ${brand.name}'s complete product portfolio: solar inverters, hybrid inverters, UPS systems, LFP batteries, energy storage, EV charging, solar modules and Solar BOS.`, canonical: `https://${brand.domain}/products` });
  return (
    <div>
      <PageHeader label="Products" title="A Complete Energy Product Portfolio" sub="From solar generation and hybrid inverters to batteries, UPS, ESS and EV charging — explore application-specific solutions for homes, businesses, industries and B2B partners." />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <Stagger className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {PRODUCTS.map((p) => (
            <motion.div key={p.slug} variants={staggerItem}>
              <Link to={`/products/${p.slug}`} data-testid={`products-page-card-${p.slug}`} className="card-surface block overflow-hidden group h-full">
                <div className="h-48 overflow-hidden relative">
                  <img src={p.image} alt={p.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  {p.featured && <span className="absolute top-3 left-3 badge-terminal !bg-emerald-500 !text-[#04261C] !border-0">Signature</span>}
                </div>
                <div className="p-6">
                  <div className="mono-label">{p.tag}</div>
                  <div className="font-display font-semibold text-white text-lg mt-1 flex items-center justify-between">{p.name} <ArrowUpRight size={18} className="text-emerald-400 opacity-0 group-hover:opacity-100 transition-opacity" /></div>
                  <p className="text-sm text-slate-400 mt-2 line-clamp-2">{p.sub}</p>
                </div>
              </Link>
            </motion.div>
          ))}
        </Stagger>
      </section>
      <CTASection />
    </div>
  );
}
